"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function addModelPermission(models, action) {
  return models.map(function (model) {
    if (model.id === action.id) {
      model.permissions ? model.permissions.push(action.data) : model.permissions = [action.data];
    }

    return model;
  });
}

exports.addModelPermission = addModelPermission;

function addPermission(model, permission) {
  model.permissions ? model.permissions.push(permission) : model.permissions = [permission];
}

exports.addPermission = addPermission;

function removeModelPermission(models, action) {
  return models.map(function (model) {
    var _a;

    if (model.id === action.id) {
      model.permissions = (_a = model.permissions) === null || _a === void 0 ? void 0 : _a.filter(function (p) {
        return p.id !== action.data;
      });
    }

    return model;
  });
}

exports.removeModelPermission = removeModelPermission;

function addModelRelation(models, action) {
  return models.map(function (model) {
    if (model.id === action.id) {
      model.relations ? model.relations.push(action.data) : model.relations = [action.data];
    }

    return model;
  });
}

exports.addModelRelation = addModelRelation;

function addRelation(model, relation) {
  model.relations ? model.relations.push(relation) : model.relations = [relation];
}

exports.addRelation = addRelation;

function removeModelRelation(models, action) {
  return models.map(function (model) {
    var _a;

    if (model.id === action.id) {
      model.relations = (_a = model.relations) === null || _a === void 0 ? void 0 : _a.filter(function (p) {
        return p.id !== action.data;
      });
    }

    return model;
  });
}

exports.removeModelRelation = removeModelRelation;